import { render, staticRenderFns } from "./order-small.vue?vue&type=template&id=39244984&scoped=true"
import script from "./order-small.vue?vue&type=script&lang=js"
export * from "./order-small.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39244984",
  null
  
)

export default component.exports